import cn from 'classnames';
import * as React from 'react';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { AlertProps } from '@tcl-argon-prefabs/alert';
import './keyframes.scss';
import { useAlertManagerClasses } from './styles';

type DivElement = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
type AlertElement = React.ReactElement<AlertProps>;

export interface AlertManagerProps extends DivElement {
  /** AlertManagers only accept one or more Alert components as children. */
  children?: AlertElement | AlertElement[];
  classes?: Record<string, string>;
  /**
   * An AlertManager manages the position of Alerts. This prop controls whether
   * the Alerts will be left, center, or right aligned
   */
  position: 'left' | 'center' | 'right';
}

export const AlertManager: React.FC<AlertManagerProps> = ({
  children,
  className,
  classes: classOverrides,
  position,
}) => {
  const classes = mergeClasses(useAlertManagerClasses({ position }), classOverrides, { root: className });

  return (
    <div className={cn(classes.root, classes.position)} data-analytics="alert-manager">
      {React.Children.map(children, (child: AlertElement) =>
        React.cloneElement(child, {
          ...child.props,
          className: classes.alertAnimation,
        }),
      )}
    </div>
  );
};
